<div
  class="tree-node"
  [attr.data-testid]="'tree-node-' + node.id"
>
  <div 
    class="tree-node__item"
    [class.tree-node__item--selected]="selectionTarget?.id === node.id && selectionTarget?.type === node.type"
    [class.tree-node__item--dictionary]="node.type === 'dictionary'"
    [class.tree-node__item--drop-inside]="isDropInside()"
    [style.padding-left.px]="12 + (level * 20)"
    (click)="onNodeClick()"
    [attr.draggable]="isEditor && node.type === 'dictionary'"
    (dragstart)="onDragStart($event)"
    (dragend)="onDragEnded()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    @if (node.type === 'category' && node.children && node.children.length > 0) {
      <button 
        class="tree-node__toggle"
        (click)="onToggle($event)"
        [attr.aria-expanded]="node.expanded"
        data-testid="button-toggle-node"
      >
        <svg 
          class="tree-node__chevron"
          [class.tree-node__chevron--expanded]="node.expanded"
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          stroke-width="2"
        >
          <path d="m9 18 6-6-6-6"/>
        </svg>
      </button>
    } @else {
      <span class="tree-node__spacer"></span>
    }
    
    @if (showCheckboxes) {
      <input
        #nodeCheckbox
        type="checkbox"
        class="tree-node__checkbox"
        [class.tree-node__checkbox--disabled]="isFolderEmpty()"
        [checked]="node.type === 'dictionary' ? isNodeSelected(node.id) : isFolderChecked()"
        [disabled]="isFolderEmpty()"
        (click)="onCheckboxClick($event)"
        (change)="onCheckboxChange($event)"
        [attr.data-testid]="'checkbox-' + node.id"
      />
    }
    
    <span class="tree-node__icon">
      @if (node.type === 'dictionary') {
        <!-- <img src="assets/design-system/icons/20/table.svg" alt="" aria-hidden="true" /> -->
        <ds-icon name="table" sizeIcon="s" />
      } @else {
        <!-- <img
          [src]="node.expanded ? 'assets/design-system/icons/20/folder-open.svg' : 'assets/design-system/icons/20/folder.svg'"
          alt=""
          aria-hidden="true"
        /> -->
        @if (!node.expanded) {
        <ds-icon name="folder" sizeIcon="s" />
        } @else {
          <ds-icon name="folder-open" sizeIcon="s" />
        }
      }
    </span>
    
    @if (isEditor && node.type === 'dictionary') {
      <span
        class="tree-node__drag-handle"
        title="Drag to move table"
        (click)="$event.stopPropagation()"
        data-testid="drag-handle-node"
      >
        <!-- <img src="assets/design-system/icons/20/menu-vertical-dots.svg" alt="" aria-hidden="true" /> -->
        <!-- <ds-icon name="menu-vertical-dots" sizeIcon="s" /> -->
      </span>
    }

    <div class="tree-node__label">
      <ds-tooltip [text]="node.name" position="bottom" alignment="center">
        <span class="tree-node__name text-ellipsis">{{ node.name }}</span>
      </ds-tooltip>
    </div>
    @if (isDropInside()) {
      <div class="tree-node__drop-overlay">
        <span class="tree-node__drop-hint text-ellipsis">{{ getDropPreviewText() }}</span>
      </div>
    }
    
    @if (isEditor) {
      <div class="tree-node__actions">
        @if (node.type === 'category') {
          <button 
            type="button"
            ds-button
            class="tree-node__action ds-button-xs icon-button ds-button-tertiary-subtle"
            (click)="onAddChild($event)"
            title="Add child"
            data-testid="button-add-child"
          >
            <!-- <img src="assets/design-system/icons/20/add.svg" alt="" aria-hidden="true" /> -->
            <ds-icon name="add" sizeIcon="s" />
          </button>
        }
        <button 
          type="button"
          ds-button
          class="tree-node__action ds-button-xs icon-button ds-button-tertiary-subtle"
          (click)="onEdit($event)"
          title="Edit"
          data-testid="button-edit-node"
        >
          <!-- <img src="assets/design-system/icons/20/pencil.svg" alt="" aria-hidden="true" /> -->
          <ds-icon name="pencil" sizeIcon="s" />
        </button>
        <button 
          type="button"
          ds-button
          class="tree-node__action ds-button-xs icon-button ds-button-tertiary-subtle"
          (click)="onDelete($event)"
          title="Delete"
          data-testid="button-delete-node"
        >
          <!-- <img src="assets/design-system/icons/20/trash.svg" alt="" aria-hidden="true" /> -->
          <ds-icon name="trash" sizeIcon="s" />
        </button>
      </div>
    }
  </div>
  
  @if (node.expanded && node.children && node.children.length > 0) {
    <div class="tree-node__children" role="group">
      @for (child of node.children; track hierarchyRowKey(child)) {
        <app-tree-node
          [node]="child"
          [level]="level + 1"
          [isEditor]="isEditor"
          [selectionTarget]="selectionTarget"
          [showCheckboxes]="showCheckboxes"
          (nodeClick)="nodeClick.emit($event)"
          (nodeToggle)="nodeToggle.emit($event)"
          (nodeEdit)="nodeEdit.emit($event)"
          (nodeDelete)="nodeDelete.emit($event)"
          (nodeSelect)="nodeSelect.emit($event)"
          (nodeAddChild)="nodeAddChild.emit($event)"
          (nodeMove)="nodeMove.emit($event)"
        />
      }
    </div>
  }
</div>
